import(/* webpackMode: "eager" */ "/app/app/calculator/Calculator.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/calculator/CalculatorClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalculatorProvider"] */ "/app/app/calculator/CalculatorContext.tsx");
